import router from 'next/router';

import { ForgotPasswordComponent } from '@app/components/auth/ForgotPasswordComponent';
import { withLayout } from '@app/components/withLayout';

const ForgotPasswordPage: React.FC = () => {
  const handleForgotPassword = (email: any) => {
    try {
      sessionStorage.setItem('email', typeof email === 'string' ? email : (email as any).value);
    } finally {
      router.push('/auth/otp?action=forgot-password');
    }
  };
  return <ForgotPasswordComponent onForgotPassword={handleForgotPassword} />;
};

export default withLayout(ForgotPasswordPage, 'auth');
